module.exports = __webpack_public_path__ + "img/mehtas.59afe96d.jpg";